// extracted by mini-css-extract-plugin
module.exports = {"layout":"video_layout__lqMqM","videoContainer":"video_videoContainer__rOA_E","content":"video_content__H_F5Q","bgLower":"video_bgLower__Sxb5S"};